import TitleFieldTemplate from "./TitleFieldTemplate";

export default TitleFieldTemplate;